import { useEffect, type RefObject } from "react";

export function useSyncIndeterminate(
  localRef: RefObject<HTMLInputElement>,
  isIndeterminate: boolean | undefined
) {
  useEffect(() => {
    if (localRef.current) {
      localRef.current.indeterminate = Boolean(isIndeterminate);
    }
  }, [isIndeterminate]);
}
